module.exports = __webpack_public_path__ + "img/9788936456665.c16e8fc7.jpg";